/**
 *
 * http配置
 *
 */
import router from '@/router'
import {LoadingBar,Notice} from 'view-design';
import axios from 'axios'
// 超时时间
axios.defaults.timeout = 30000
// 跨域请求，允许保存cookie
axios.defaults.withCredentials = true
// HTTPrequest拦截
axios.interceptors.request.use(config => {
  LoadingBar.start();
  return config
}, error => {
  LoadingBar.error();
  console.log('加载超时');
  return Promise.reject(error)
})
// HTTPresponse拦截
axios.interceptors.response.use(data => {
  LoadingBar.finish();
  if(data.data.code==='401'){
    Notice.destroy()
    Notice.info({desc: '登录已过期,请重新登录!'});
    router.push("/login");
  }
  return data
}, error => {
  LoadingBar.error();
  console.log('加载失败');
  return Promise.reject(error)
})

export default axios



// WEBPACK FOOTER //
// ./src/axios/axios.js